
import { defineComponent } from "vue";
import TheNavigationBar from "../components/TheNavigationBar.vue";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
const getAudio = () => {
  const audio = document.getElementById("audio-player") as HTMLAudioElement;
  const duration = audio.duration;
  return {
    audio,
    duration,
  };
};
document.addEventListener("DOMContentLoaded", getAudio);
export default defineComponent({
  components: { TheNavigationBar,VueSlider },
  setup() {
    return {
      getAudio,
    };
  },
  mounted(){
   this.findTrack()
  },
  data() {
    return {
      duration: "00:00",
      brickHeight: 4,
      canvaHeight: 64,
      slider: 0,
      audioValue:0,
      volumeValue:5,
      trackName:'',
      tracks:[{title:'Another One Bites The Bites',
artist:'Queen',id:1,slug:'bites'},{title:'Say you, Say me',artist:'Lionel Richie',id:2,slug:'say'},{title:'Never Gonna Give You Up', artist:'R.Astley',id:3,slug:'slug'}]
    };
  },
  methods: {
    playAudio() {
      this.getAudio().audio.play();
      const changeicon = document.querySelector('.changePlayIcon') as HTMLElement;
      changeicon.classList.remove('fa-play');
      changeicon.classList.add('fa-pause');
      document.querySelector('.animate-paragraph')?.classList.add('move')
      this.getAudio().audio.addEventListener("timeupdate", () => {
      this.audioValue = this.getAudio().audio.currentTime / this.getAudio().audio.duration * 100  
      this.duration = this.convertTime(this.getAudio().audio.currentTime) 
      });
    },
    findTrack(index:number=0){
       

},  
    pauseAudio() {
      this.getAudio().audio.pause();
      const changeicon = document.querySelector('.changePlayIcon') as HTMLElement;
      changeicon.classList.remove('fa-pause');
      changeicon.classList.add('fa-play');
    },
    stopAudio() {
      this.getAudio().audio.pause();
      document.querySelector('.animate-paragraph')?.classList.remove('move')
      const changeicon = document.querySelector('.changePlayIcon') as HTMLElement;
      changeicon.classList.contains('fa-pause') ? changeicon.classList.replace('fa-pause','fa-play'):'';
      this.getAudio().audio.currentTime = 0;
    },
    loop(){
      this.getAudio().audio.loop ? this.getAudio().audio.loop = false : this.getAudio().audio.loop = true;
      const loopBtn = document.querySelector('.loopBtn') as HTMLElement;
      this.getAudio().audio.loop ? loopBtn.classList.replace('text-greyDark','text-green-400') : loopBtn.classList.replace('text-green-400','text-greyDark')
    },

    //Convert audio current time from seconds to min:sec display
    convertTime(seconds: number) {
      const format = (val) => `0${Math.floor(val)}`.slice(-2);
      let hours = seconds / 3600;
      let minutes = (seconds % 3600) / 60;
      return [minutes, seconds % 60].map(format).join(":");
    },
   changePosition(value: number) {
      this.getAudio().audio.currentTime = value / 100 * this.getAudio().duration;
    },
    changeVolume(value: number) {
      this.getAudio().audio.volume = value / 100;
    },
    mute(){
      const muteBtn = document.querySelector('.muteIcon') as HTMLElement;
      this.getAudio().audio.muted ? this.getAudio().audio.muted = false : this.getAudio().audio.muted = true;
      this.getAudio().audio.muted ? muteBtn.classList.replace('text-greyDark','text-red-400') : 
  
      muteBtn.classList.replace('text-red-400','text-greyDark')
    }   
  }
});
